import { render } from "./UpdateCard.vue?vue&type=template&id=6ce1962e&scoped=true"
import script from "./UpdateCard.vue?vue&type=script&lang=js"
export * from "./UpdateCard.vue?vue&type=script&lang=js"

import "./UpdateCard.vue?vue&type=style&index=0&id=6ce1962e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ce1962e"]])

export default __exports__
import QItem from 'quasar/src/components/item/QItem.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QItem,QChip});
